import { TriggerAction, TriggerActionType } from './TriggerActions'

export interface TriggerState {
    onFirstGameExit: OnFirstGameExitTriggerState
    onCashierModalOpened: OnCashierModalOpenedTriggerState
}

export interface OnFirstGameExitTriggerState {
    pokerGamesExited: number
    casinoGamesExited: number
}

export interface OnCashierModalOpenedTriggerState {
    modalButtonClicks: number
}

const initialState: TriggerState = {
    onFirstGameExit: {
        pokerGamesExited: 0,
        casinoGamesExited: 0,
    },
    onCashierModalOpened: {
        modalButtonClicks: 0
    },
}

export const triggerReducer = (
    state: TriggerState = initialState,
    action: TriggerAction
): TriggerState => {
    switch (action.type) {
        case TriggerActionType.POKER_GAME_EXITED:
            return {
                ...state,
                onFirstGameExit: {
                    ...state.onFirstGameExit,
                    pokerGamesExited: state.onFirstGameExit.pokerGamesExited + 1,
                }
            }
        case TriggerActionType.CASINO_GAME_EXITED:
            return  {
                ...state,
                onFirstGameExit: {
                    ...state.onFirstGameExit,
                    casinoGamesExited: state.onFirstGameExit.casinoGamesExited + 1,
                }
            }
        case TriggerActionType.CASHIER_MODAL_OPENED:
            return {
                ...state,
                onCashierModalOpened: {
                    ...state.onCashierModalOpened,
                    modalButtonClicks: state.onCashierModalOpened.modalButtonClicks + 1,
                }
            }
        default:
            return state
    }
}
